module.exports = __webpack_public_path__ + "static/media/bi5.26c731c7.png";